const LiveEdit = {
	wrappers: null,
	init: () => {
		LiveEdit.wrappers = document.querySelectorAll(`[data-live-edit-wrapper]`);
		if(LiveEdit.wrappers.length === 0) return;
		LiveEdit.initDefaultValues();
		LiveEdit.initLiveEditInputListener();
		LiveEdit.recalculateFontSize();
		LiveEdit.initResizeListener();
	},

	initResizeListener: () => {
		window.addEventListener('resize', () => {
			LiveEdit.recalculateFontSize();
		});
	},

	recalculateFontSize: () => {

		LiveEdit.wrappers.forEach((wrapper) => {
			const sizes = wrapper.getBoundingClientRect();
			const textElement = wrapper.querySelector('[data-live-edit-text]');
			const percent = parseFloat(textElement.getAttribute('data-live-edit-text'))/100;
			const fontsize = sizes.height * percent;
			textElement.style.fontSize = `${fontsize}px`;
		})
	},

	initDefaultValues: () => {
		LiveEdit.wrappers.forEach((wrapper) => {
			LiveEdit.setText(wrapper, wrapper.getAttribute('data-live-edit-default'));
		})
	},

	initLiveEditInputListener: () => {
		const inputs = document.querySelectorAll(`[data-live-edit]`);
		inputs.forEach((element) => {
		    element.addEventListener('keyup', (ev) => {
				LiveEdit.wrappers.forEach((wrapper) => {
					let text = element.value;
					if(!text){
						text = wrapper.getAttribute('data-live-edit-default');
					}
					LiveEdit.setText(wrapper, text);
				})
			});
		})
	},
	setText: (wrapper, text) => {
		text = text.trim().substring(0, 12)
		wrapper.setAttribute('data-live-edit-wrapper', text);
		wrapper.querySelector('[data-live-edit-text]').innerText = text;
	}
}

export default LiveEdit;
